<template>
  <nx-color-picker
    v-validate="computedValidation"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :value="value"
    :name="name"
    :label="label"
    :disabled="disabled"
    :error-messages="errorMessages"
    data-vv-value-path="value"
    data-vv-validate-on="input|blur"
    @input="onInput($event)"
    @focus="onFocus($event)"
    @blur="onBlur($event)"
    v-bind="$attrs"
  ></nx-color-picker>
</template>
<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxColorPicker from '@/components/color/ColorPicker';

export default {
  name: 'nx-form-color-picker',
  mixins: [FormElement],
  components: {
    [NxColorPicker.name]: NxColorPicker,
  },
  data() { return {}; },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    computedValidation() {
      return {
        ...this.validation,
        regex: /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/,
      };
    },
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
      this.$parentForm.updateField(this.name, newValue);
    },
    onBlur() {
      this.$emit('blur', true);
      this.flags.focused = false;
    },
    onFocus() {
      this.$emit('focus', true);
      this.flags.focused = true;
    },
  },
};
</script>
<style>
</style>
